<template>
  <div class="row justify-content-center m-0">
    <div class="col-md-10 p-5">
      <swiper
        :spaceBetween="30"
        :centeredSlides="true"
        :autoplay="{
          delay: 3500,
          disableOnInteraction: false,
        }"
        :pagination="{
          clickable: true,
        }"
        :navigation="true"
        :modules="modules"
        :zoom="true"
        class="mySwiper"
      >
        <swiper-slide class="swiper-slide"
          ><img
            src="../assets/energiespartüren/koe_ES01_600_DarkFSM.jpg"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/energiespartüren/koe_ES02_600_DeepBlackFS.jpg"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/energiespartüren/koe_ES03_600_SparklingIronFSM.jpg"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/energiespartüren/koe_ES04_600_PurpleFS.jpg"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/energiespartüren/koe_ES05_600_WhiteAluminiumFSM.jpg"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/energiespartüren/koe_ES06_600_QuarzgreyFS.jpg"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/energiespartüren/koe_ES07_600_DarkFSM.jpg"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/energiespartüren/koe_ES08_600_DarkFSM.jpg"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img
            src="../assets/energiespartüren/koe_ES09_600_SparklingIronFSM.jpg"
            class="swiper-slide rundeEcken" /></swiper-slide
        ><swiper-slide
          ><img src="../assets/energiespartüren/koe_ES10_600_Basaltgrey.jpg" class="swiper-slide rundeEcken"
        /></swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<!-- 
HILFE !!
https://swiperjs.com/demos#effect-fade 
-->

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/effect-flip";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "../assets/mySwiper.css";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay, Pagination, Navigation],
    };
  },
};
</script>
